export default function logError(errorMessage: string) {
  console.error(errorMessage);
  alert(errorMessage);
}